export default "__VITE_ASSET__Dn9ujPTR__"